import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Badge.module.css";
import { cx } from "../cx";

export type BadgeTone =
  | "brand"
  | "brandSolid"
  | "neutral"
  | "critical"
  | "criticalWeak"
  | "informative"
  | "positive"
  | "warning";

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: BadgeTone;
  icon?: ReactNode;
  children: ReactNode;
};

/** SEED Badge (Figma 38:268). 높이 20, t2 Bold. */
export function Badge({ tone = "brand", icon, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cx(styles.root, styles[tone], className)} {...rest}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {children}
    </span>
  );
}
